import { css } from 'styled-components';
import React from 'react';

export const spaceProps = ['mt', 'mr', 'mb', 'ml', 'm', 'pt', 'pr', 'pb', 'pl', 'p'];

const getSmallestMediaQueryKey = obj => {
  return Object.keys(obj)
    .sort()
    .reverse()[0];
};

export const spaceOptions = () => css`
  ${responsiveAttr('m', 'margin')};
  ${responsiveAttr('mt', 'margin-top')};
  ${responsiveAttr('mr', 'margin-right')};
  ${responsiveAttr('mb', 'margin-bottom')};
  ${responsiveAttr('ml', 'margin-left')};
  ${responsiveAttr('p', 'padding')};
  ${responsiveAttr('pt', 'padding-top')};
  ${responsiveAttr('pr', 'padding-right')};
  ${responsiveAttr('pb', 'padding-bottom')};
  ${responsiveAttr('pl', 'padding-left')};
`;

export const responsiveAttr = (propName, attr) => props => {
  const value = props[propName];

  if (typeof value === 'undefined' || value === null) {
    return;
  }

  if (typeof value === 'number' || typeof value === 'string') {
    return css`${attr}: ${inferUnits(value)}`;
  }

  if (typeof value === 'object') {
    return css`
      @media (max-width: ${props => props.theme.breakpoints[getSmallestMediaQueryKey(value)]}rem) {
        ${attr}: ${inferUnits(value[getSmallestMediaQueryKey(value)])}${
      typeof value[getSmallestMediaQueryKey(value)] === 'number' ? '' : 'px'
    };
      }

      ${Object.keys(value).map(
        bp => `
        @media (min-width: ${props.theme.breakpoints[bp]}rem) {
          ${attr}: ${inferUnits(value[bp])};
        }
      `
      )};
    `;
  }
};

export const margin = responsiveAttr('m', ' margin');
export const marginTop = responsiveAttr('mt', 'margin-top');
export const marginLeft = responsiveAttr('ml', 'margin-left');
const inferUnits = value => {
  if (typeof value === 'number') {
    return `${value}rem`;
  }
  return value;
};

export const mediaBreakpointUp = breakpoint => props =>
  `@media (min-width: ${props.theme.breakpoints[breakpoint]}rem`;

export const depreciateComponent = message => WrappedComponent => {
  // In prod, no nothing; Webpack should complile this out.
  if (process.env.NODE_ENV === 'production') {
    return WrappedComponent;
  }
  class DepCompomnent extends React.Component {
    componentWillMount() {
      console.warn(`[ HUI ] ⚠️ ${message})`); // eslint-disable-line no-console
    }
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  return DepCompomnent;
};
